package com.ustadmobile.core.impl.appstate

enum class AppBarColors {

    STANDARD, SELECTION_MODE

}